/* eslint-disable max-len */
// eslint-disable-next-line no-unused-vars
import React, { useCallback } from 'react';
import { Flex, Text, Button, Dialogs, Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';

// import Accordion from '../../../../../views/Accordion'
import Accordion from "./Accordion.js";
import TRLoader from "./TRLoader.js";
import S from './TheftRecovery.css';
import DisableDialog from "./DisableDialog.js"; // import { theftRecoverySupport } from '../Templates'
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovrGeneric.assetIndustryName');
export default class TheftRecoveryActive extends React.Component {
  onClick = () => {
    Dialogs.show({
      component: DisableDialog,
      props: {
        ...this.props
      }
    });
  };
  onShareAccess = () => {
    const {
      caseActions,
      sharedProps
    } = this.props;
    const {
      history
    } = sharedProps;
    const caseId = caseActions.id;
    const theftCasesGroupDelegate = caseActions.parent();
    if (theftCasesGroupDelegate.isGotoAllowed()) {
      const url = theftCasesGroupDelegate.getUrl();
      if (caseId === undefined) {
        Toast.error('Theft case not found');
        return;
      }
      GlobalState.dispatch(history.push(`${url}/${caseId}/temporaryAccess`));
    }
  };
  onClickCaseNumber = () => {
    const {
      caseActions
    } = this.props;
    const id = caseActions.id;
    GlobalState.dispatch(caseActions.parent().goTo(id));
  };

  // contactSupport = () => {
  //   const { onClose, sharedProps : { item } } = this.props
  //   const messageText = theftRecoverySupport.replace( '$VIN', item?.data?.vin || 'Unknown' )
  //   window?.Intercom?.( 'showNewMessage', messageText )
  //   onClose?.()
  // }

  // onChange = ( { data, value } ) => {
  //   const { setLoading } = this.props
  //   setLoading( value )
  // }

  render() {
    const {
      loading,
      userHasAccess,
      caseData
    } = this.props;
    const uiName = process.env.UI_NAME;
    const assetIndustryName = t(uiName, 'Asset');
    return /*#__PURE__*/_jsxs(Flex, {
      variant: "colL",
      style: {
        gap: '0px'
      },
      children: [!caseData && /*#__PURE__*/_jsx(TRLoader, {
        spinning: true
      }), caseData && /*#__PURE__*/_jsxs(Flex, {
        justify: "space-between",
        align: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          children: " View Case Number "
        }), /*#__PURE__*/_jsx(Button, {
          variant: "link",
          style: {
            paddingRight: '0px'
          },
          onClick: this.onClickCaseNumber,
          children: caseData.data.caseId
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        justify: "space-between",
        align: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          children: " Share Access To Case "
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: this.onShareAccess,
          children: "Share"
        })]
      }), /*#__PURE__*/_jsx(Flex, {
        variant: "colL",
        style: {
          border: '1px solid var( --color-base100 )',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '16px',
          marginTop: '8px',
          backgroundColor: '#F3F5F6'
        },
        children: /*#__PURE__*/_jsx(Accordion, {
          title: /*#__PURE__*/_jsxs(Flex, {
            variant: "rowM",
            children: [/*#__PURE__*/_jsx("img", {
              src: "https://recovr-ui-assets.storage.googleapis.com/icon-system-error-2x.png",
              alt: "Theft Recovery Icon",
              width: "24px",
              height: "24px"
            }), /*#__PURE__*/_jsx(Text, {
              style: {
                fontWeight: 700
              },
              children: "This will NOT contact the police. Please call 911 to file a police report."
            })]
          }),
          content: /*#__PURE__*/_jsxs(Flex, {
            className: S.list,
            variant: "colM",
            style: {
              marginLeft: '0px',
              marginTop: 'var( --size-padLarge )'
            },
            children: [/*#__PURE__*/_jsx("hr", {
              style: {
                border: 'none',
                borderTop: '1px solid var( --color-base200 )',
                width: '100%',
                margin: '0px',
                paddingBottom: '2px'
              }
            }), /*#__PURE__*/_jsx(Text, {
              style: {
                fontWeight: 700,
                fontSize: '13px'
              },
              children: " Notes for Contacting Law Enforcement:"
            }), /*#__PURE__*/_jsxs("ul", {
              style: {
                paddingLeft: '24px',
                margin: '0px'
              },
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsxs(Text, {
                  style: {
                    fontWeight: 400,
                    fontSize: '13px'
                  },
                  children: ["Express that your ", assetIndustryName, " has been stolen"]
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsxs(Text, {
                  style: {
                    fontWeight: 400,
                    fontSize: '13px'
                  },
                  children: ["Mention that you have a RecovR Security Device hidden in your ", assetIndustryName, " which you have activated to actively track the ", assetIndustryName, " location"]
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Text, {
                  style: {
                    fontWeight: 400,
                    fontSize: '13px'
                  },
                  children: "Share access to the theft case by creating temporary access accounts"
                })
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Button, {
        disabled: !userHasAccess || loading,
        onClick: this.onClick,
        variant: "primaryDestructive",
        className: S.button,
        children: "Deactivate Theft Recovery"
      })]
    });
  }
}